<div class="py-4 md:py-2 text-center" *ngIf="loader">
    <div class="inline-block animate-spin rounded-full border-4 border-solid border-current text-primary border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
        role="status" [style.width]="size" [style.height]="size">
        <span
            class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
    </div>
</div>
<ng-content *ngIf="!loader"></ng-content>